// import $ from 'jquery';

import 'jquery-ui/dist/jquery-ui.js';
/* If we dont do this, the datepicker collides with bootstrap's / editable's datepicker */
$.fn.datepicker = undefined;

import 'jquery-ui-touch-punch';
import 'jquery-highlight';
import 'jquery-validation/dist/jquery.validate.js';
import 'jquery-validation/dist/additional-methods.js';

require('jquery-validation/dist/localization/messages_de.js');
require('jquery-validation/dist/localization/messages_da.min.js');
require('jquery-validation/dist/localization/messages_es.min.js');
require('jquery-validation/dist/localization/messages_sv.min.js');
require('jquery-validation/dist/localization/messages_tr.min.js');
require('jquery-validation/dist/localization/messages_ro.min.js');
require('jquery-validation/dist/localization/messages_fr.min.js');
require('jquery-validation/dist/localization/messages_it.min.js');
require('jquery-validation/dist/localization/messages_ru.min.js');


import 'ua-parser-js/dist/ua-parser.pack.js';

globalThis.$.validator = $.validator;

